// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import { installTurboConfirm } from "./turbo_confirm"

installTurboConfirm(Turbo)
